export const environment = {
  version: 'c782cf9c99209bcde8351218373465a2dabe9ef1',
  buildDate: '202608311631',
  environment: 'release-kw34',
  production: false,
  debug: true,
  dash0Enabled: true,
  baseUrl: 'https://develop.jobboard.catch-talents.dev',
  apiBaseUrl: 'https://release-kw34.api.catch-talents.dev',
  apiBaseUrlFallback: 'https://develop.api.catch-talents.dev',
};
